import React, { createContext, ReactNode, useContext, useState } from 'react'

interface ToSModalContextType {
  showToSModal: boolean
  setShowToSModal: (value: boolean) => void
}
const ToSModalContext = createContext<ToSModalContextType | undefined>(
  undefined
)

export const TermsModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [showToSModal, setShowToSModal] = useState<boolean>(false)

  return (
    <ToSModalContext.Provider value={{ showToSModal, setShowToSModal }}>
      {children}
    </ToSModalContext.Provider>
  )
}

export const useTermsModal = (): ToSModalContextType => {
  const context = useContext(ToSModalContext)
  if (!context) {
    throw new Error('useToSModal must be used within a ToSModalProvider')
  }
  return context
}
